const NewResourceCallRateStatistics = () =>
  import(
    '@/views/main/wechatMgmt/newResourceCallRateStatistics/NewResourceCallRateStatistics.vue'
  )
export default {
  path: '/main/wechatMgmt/newResourceCallRateStatistics',
  name: 'NewResourceCallRateStatistics',
  component: NewResourceCallRateStatistics
}
